import { useSyncExternalStore } from 'react';
import {
  getBoundsSnapshot,
  getServerBoundsSnapshot,
  subscribeToBounds,
} from './boundsStore';

import { type Bounds } from './getWindowBounds';

export type { Bounds };

/**
 * Returns current window bounds and re-renders when the viewport resizes.
 * Uses useSyncExternalStore so React Compiler can track subscription updates.
 */
export const useBounds = (): Bounds => {
  return useSyncExternalStore(
    subscribeToBounds,
    getBoundsSnapshot,
    getServerBoundsSnapshot,
  );
};
